import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

const TABS_WRAPPER_HEIGHT = 48;
const NAVIGATION_HEIGHT = 122;
export const NAVIGATION_TOP_MARGIN = TABS_WRAPPER_HEIGHT + NAVIGATION_HEIGHT;

export const StyledTabsWrapper = styled.div`
    z-index: 2;
    position: sticky;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    height: ${TABS_WRAPPER_HEIGHT}px;
    width: 100%;
    margin: 0 auto;
    background: transparent;
    top: -1px;

    &.isSticky {
        border-bottom: 2px solid ${colorsPalettes.carbon[50]};
        background: ${colorsPalettes.carbon[0]};
    }

    &.isSticky::after {
        content: "";
        position: absolute;
        top: 48px;
        height: 31px;
        width: 100%;
        background: linear-gradient(rgba(0, 0, 0, 0.08) 0%, rgba(0, 0, 0, 0) 100%);
        pointer-events: none;
    }
`;

export const StyledTabs = styled.div`
    width: 100%;
    max-width: 1366px;
    padding: 0 40px;

    .si-sticky-tab,
    .si-sticky-tab-selected {
        min-width: 142px;
        padding: 16px 20px;
        line-height: 16px;
        text-transform: unset;
        ${mixins.setFontVariant("tab", colorsPalettes.carbon["300"])};
    }

    .si-sticky-tab {
        svg path {
            fill: ${colorsPalettes.carbon["300"]};
        }

        &:hover {
            color: ${colorsPalettes.carbon["400"]};

            svg path {
                fill: ${colorsPalettes.carbon["400"]};
            }
        }
    }

    .si-sticky-tab-selected {
        color: ${colorsPalettes.blue["400"]};
        cursor: pointer;

        svg path {
            fill: ${colorsPalettes.blue["400"]};
        }

        &:after {
            border-bottom-color: ${colorsPalettes.blue["400"]};
        }
    }
`;
